module.exports = __webpack_public_path__ + "img/5.a55af476.jpg";